import { OrganizationInfo } from '../types';
import apiRequest from './apiRequest';

export default async function deleteOrganizationMember(
  organizationID: string,
  userIDOrEmailAddress: string,
) {
  return apiRequest<{ organizationInfo: OrganizationInfo }>(
    'user',
    `/organizations/${organizationID}/${encodeURIComponent(userIDOrEmailAddress)}`,
    {
      method: 'DELETE',
    },
  );
}
